module.exports = __webpack_public_path__ + "static/media/homeImage.e89c2d06.webp";